import React, { useState, useRef, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Close from '@mui/icons-material/Close';
import Button from 'react-bootstrap/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Editor } from '@tinymce/tinymce-react';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import { sendSingleEmail, askGPT } from '../../../common/api';
import { toast } from 'react-toastify';
import { createFile } from '../../../common/api';
import { storeMedia, createId, extractImages, getMimeTypeFromExtension } from '../../../common/utils';
import { IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import ChipInput from 'material-ui-chip-input';
import LeoSuggestionBar from '../../Leo/Suggestion';
import ScheduleButton from '../../Modals/ScheduleButton';


const EmailInput = ( { label, emails, setEmails } ) => {
    const handleAddChip = ( chip ) => {
        console.log( 'adding: ', chip );
        setEmails( [ ...emails, chip ] );
    };

    const handleDeleteChip = ( idx ) => {
        console.log( 'deleting: ', idx );
        setEmails( emails.filter( ( addr, i ) => i !== idx ) );
    };

    const validateEmail = ( chip ) => {
        console.log( 'validating: ', chip );
        const allowed = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return chip.match( allowed );
    };
  
    return (
            <Row className='align-items-center'>
                <Col xs='auto'>
                    {label}
                </Col>
                <Col className='tf-email-chip me-1 d-flex align-items-center'>
                    <ChipInput 
                        value={emails}
                        onBeforeAdd={ ( chip ) => validateEmail( chip ) }
                        onAdd={ ( chip ) => handleAddChip( chip ) } 
                        onDelete={ ( chip, index ) => handleDeleteChip( index ) } 
                        disableUnderline={true}
                        newChipKeyCodes={ [ 9, 13, 32, 186, 188 ] } // Tab, Enter, Space, Semicolon, Comma
                        fullWidth
                    />
                </Col>
            </Row>
    );
};

const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    zIndex: 10,
    pointerEvents: 'none',
};

const EmailSingle = React.forwardRef( ( { open, onClose, onMinimize, uid, user, contacts, opps, loans, globalStatus, loanStatus, obj, objType, tmpl, tmplContent, sub, attachment }, ref ) => {
    const [ minimized, setMinimized ] = useState( false );
    const [ showCc, setShowCc ] = useState( false );
    const [ showBcc, setShowBcc ] = useState( false );
    const [ from, setFrom ] = useState( '' );
    const [ signature, setSignature ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ to, setTo ] = useState( [] );
    const [ cc, setCc ] = useState( [] );
    const [ bcc, setBcc ] = useState( [] );
    const [ recipSuggestions, setRecipSuggestions ] = useState( [ { name: 'BTS', email: 'support@thirdfloor.ai' } ] );
    const [ subject, setSubject ] = useState( '' );
    const [ body, setBody ] = useState( '' );
    const [ attachments, setAttachments ] = useState( [] );
    const [ showVideo, setShowVideo ] = useState( false );
    const [ showChatGPT, setShowChatGPT ] = useState( false );
    const [ prompt, setPrompt ] = useState( '' );
    const [ waiting, setWaiting ] = useState( false );
    const [ displayText, setDisplayText ] = useState( '' );
    const [ chatResp, setChatResp ] = useState( '' );
    const [ replace, setReplace ] = useState( false );
    const [ promptType, setPromptType ] = useState( 'freeform' );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ tmplUsed, setTmplUsed ] = useState( '' );
    const [ aiEnabled, setAiEnabled ] = useState( false );
    const [ isDragActive, setIsDragActive ] = useState( false );
    const [ sending, setSending ] = useState( false );
    const [ includeTask, setIncludeTask ] = useState( false );
    const [ taskType, setTaskType ] = useState( 'To-Do' );
    const [ taskDay, setTaskDay ] = useState( '' );
    const [ editorHeight, setEditorHeight ] = useState( 360 );
    const [ loading, setLoading ] = useState( true );
    
    const containerRef = useRef( null );
    const windowHeaderRef = useRef( null );
    const metaRef = useRef( null );
    const attachmentsRef = useRef( null );
    const actionsRef = useRef( null );
    const leoRef = useRef( null );
    const editorRef = useRef( null );
    const tmplRef = useRef( null );
    tmplRef.current = allTmpls;
    const senderRef = useRef( null );
    senderRef.current = senderList;
    const bbObjRef = useRef( null );
    const objRef = useRef( null );
    objRef.current = obj;
    const objTypeRef = useRef( null );
    objTypeRef.current = objType;
    const uidRef = useRef( null );
    uidRef.current = uid;
    const fileInputRef = useRef( null );
    
    const sendEmail = async () => {
        alert( 'send email' );
    }

    const handleDragEnter = (event) => {
        event.preventDefault();
        setIsDragActive( true );
    };
      
    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragActive( true );
    };
      
    const handleDragLeave = (event) => {
        event.preventDefault();
        setIsDragActive( false );
    };

    const handleFileChange = async ( event ) => {
        const selectedFiles = Array.from( event.target.files );
        const uploadedFiles = await Promise.all( selectedFiles.map( file => storeFile( file ) ) );
        event.target.value = null;
    };
    
    const storeFile = async ( f ) => {
        const reader = new FileReader();
            
        reader.onabort = () => {
            toast.success( `The upload process on ${f.path} has been aborted`, { theme: 'dark' } );
        }
        reader.onerror = () => {
            toast.success( `There's been an error while uploading ${f.path}`, { theme: 'dark' } );
        }
        reader.onload = async () => {
            const b = new Blob( [ reader.result ] );
            const ext = f.name.split( '.' ).pop();
            let n = createId( 'file' );
            if ( ext ) {
                n += '.' + ext;
            }
                    
            const name = await storeMedia( objRef.current.aid, uid, n, b, getMimeTypeFromExtension( ext ) );
                    
            let cid;
            let lid;

            if ( objTypeRef.current === 'contact' ) {
                cid = objRef.current.cid;
            } else if ( objTypeRef.current === 'loan' ) {
                lid = objRef.current.lid;
                const c = objRef.current.borrowers?.find( f => f.label === 'Primary' );
                if ( c ) {
                    cid = c.cid;
                }
            }

            let file = {
                mediaUrl: name,
                name: f.name
            }
            if ( cid ) {
                file['cid'] = cid;
            }
            if ( lid ) {
                file['lid'] = lid;
            }

            await createFile( objRef.current.aid, uidRef.current, file );

            setAttachments( prev => [
                ...prev,
                { name: file.name, fid: file.mediaUrl }
            ] );
            console.log( 'uploaded: ', name );
        }
        reader.readAsArrayBuffer( f );
    };

    const handleDrop = async ( event, editor ) => {
        event.preventDefault();
        setIsDragActive( false );

        const files = Array.from( event.dataTransfer.files );
        for ( const f of files ) {
            if ( f.type.startsWith( 'image/' ) ) {
                editor.insertContent( `<img src="${URL.createObjectURL( f )}" />` );
            } else {
                await storeFile( f );
            }
        }
    };

    const removeAttachment = ( file ) => {
        setAttachments( prev => {
            const list = prev.filter( f => f.name !== file );
            return [ ...list ];
        } );
    }

    const render = useCallback( ( content, noEscape = false ) => {
        if ( !content || !content.length ) {
            return '';
        }

        const t = Handlebars.compile( content );
        let params = {};

        Handlebars.registerHelper( 'isYes', function ( value ) {
            return ( value === 'Yes' );
        } );
        Handlebars.registerHelper( 'isRefi', function ( value ) {
            return value.match( /refi/i );
        } );
        Handlebars.registerHelper( 'textMatch', function ( a, b ) {
            return ( a === b );
        } );
        Handlebars.registerHelper( 'textMismatch', function ( a, b ) {
            return ( a !== b );
        } );
        Handlebars.registerHelper( 'formatMoney', function ( value ) {
            if ( !value ) {
                return '';
            }
            const sanitizedInput = value.toString().replace( /[$,]/g, '' );
            const val = parseFloat( sanitizedInput );

            // Check if the value is a number
            if ( isNaN( val ) ) {
                return '';
            }

            // Check if the input has decimal places
            const hasDecimals = ( val % 1 ) !== 0;

            // Create a formatter
            const formatter = new Intl.NumberFormat( 'en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: hasDecimals ? 2 : 0,
                maximumFractionDigits: hasDecimals ? 2 : 0,
            } );

            return formatter.format( val );
        } );
        Handlebars.registerHelper( 'formatPercentage', function ( value ) {
            const sanitizedInput = value.replace(/%/g, '');
            const val = parseFloat( sanitizedInput );

            // Check if the value is a number
            if ( isNaN( val ) ) {
                return '';
            }

            // Check if the input is already a percentage (i.e., it's greater than 1)
            const isDecimal = Math.abs( val ) <= 1;

            // Create a formatter
            const formatter = new Intl.NumberFormat( 'en-US', {
                style: 'percent',
                minimumFractionDigits: 0, // isDecimal ? 3 : 3,
                maximumFractionDigits: 3 // isDecimal ? 3 : 3,
            } );

            return formatter.format( isDecimal ? val : val / 100 );
        } );
        Handlebars.registerHelper( 'tod', function () {
            const currentHour = new Date().getHours(); // Gets the current hour (0-23)
  
            if ( currentHour < 12 ) {
                return "morning";
            } else if ( currentHour < 18 ) {
                return "afternoon";
            } else {
                return "evening";
            }
        } );
        Handlebars.registerHelper( 'formatMonthDay', function ( value ) {
            if ( !value || !value.length ) {
                return '';
            }
            const months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            const d = new Date( value.match( 'T' ) ? value : value + 'T12:00:00' );
            const day = d.getDate();
            const monthIndex = d.getMonth();
            let suffix = '';
            if ( day > 3 && day < 21 ) {
                suffix = 'th';
            } else {
                switch ( day % 10 ) {
                    case 1:
                        suffix = 'st';
                        break;
                    case 2:
                        suffix = 'nd';
                        break;
                    case 3:
                        suffix = 'rd';
                        break;
                    default:
                        suffix = 'th';
                }
            }
        
            return `${months[monthIndex]} ${day}${suffix}`;
        } );
        Handlebars.registerHelper( 'today', function () {
            const date = new Date();
            const year = date.getFullYear();
            const month = String( date.getMonth() + 1 ).padStart( 2, '0' );
            const day = String( date.getDate() ).padStart( 2, '0' );
            return `${year}${month}${day}`;
        } );
        Handlebars.registerHelper( 'todayPretty', function () {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const today = new Date();
            return today.toLocaleDateString( 'en-US', options );
        } );
        Handlebars.registerHelper( 'clientPartnerFirstNames', function ( value ) {
            if ( value.length === 0) return '';
    
            const list = [];
            value.forEach( b => {
                const c = contacts[b.cid];
                list.push( {
                    firstname: c.firstname,
                    lastname: c.lastname
                } );

                if ( c.firstnamePartner1 && c.firstnamePartner1.length ) {
                    list.push( {
                        firstname: c.firstnamePartner1,
                        lastname: c.lastnamePartner1
                    } );
                }
                if ( c.firstnamePartner2 && c.firstnamePartner2.length ) {
                    list.push( {
                        firstname: c.firstnamePartner2,
                        lastname: c.lastnamePartner2
                    } );
                }
            } );
            console.log( 'value vs list: ', value, list );
            
            const firstNames = list.map( name => name.firstname );
    
            // Handle the formatting based on the number of first names
            if (firstNames.length === 1) {
                // Only one first name
                return firstNames[0];
            } else {
                // Multiple first names, join all but the last with commas, and add 'and' before the last name
                const allButLast = firstNames.slice(0, -1).join(', ');
                const last = firstNames[firstNames.length - 1];
                return `${allButLast} and ${last}`;
            }
        } );
        Handlebars.registerHelper( 'borrowerFirstNames', function ( value ) {
            if ( value.length === 0) return '';
    
            const list = value.map( m => {
                const c = contacts[m.cid];
                return {
                    firstname: c.firstname,
                    lastname: c.lastname,
                    label: m.label
                }
            } );
            list.sort( ( a, b ) => {
                if ( a.label === 'Primary' ) {
                    return -1;		
                }
                if ( b.label === 'Primary' ) {
                    return 1;		
                }
                return 0;
            } );
            console.log( 'value vs list: ', value, list );
            
            const firstNames = list.map( name => name.firstname );
    
            // Handle the formatting based on the number of first names
            if (firstNames.length === 1) {
                // Only one first name
                return firstNames[0];
            } else {
                // Multiple first names, join all but the last with commas, and add 'and' before the last name
                const allButLast = firstNames.slice(0, -1).join(', ');
                const last = firstNames[firstNames.length - 1];
                return `${allButLast} and ${last}`;
            }
        } );
        Handlebars.registerHelper( 'partnerFirstNames', function ( value ) {
            if ( value.length === 0) return '';
            const list = [];

            value.forEach( m => {
                const c = contacts[m.cid];
                list.push( {
                    firstname: c.firstname,
                    lastname: c.lastname,
                    label: 'Primary'
                } );
                if ( c.firstnamePartner1 ) {
                    list.push( {
                        firstname: c.firstnamePartner1,
                        lastname: c.lastnamePartner1,
                        label: 'Partner'
                    } );
                }
                if ( c.firstnamePartner2 ) {
                    list.push( {
                        firstname: c.firstnamePartner2,
                        lastname: c.lastnamePartner2,
                        label: 'Partner'
                    } );
                }
            } );
            list.sort( ( a, b ) => {
                if ( a.label === 'Primary' ) {
                    return -1;		
                }
                if ( b.label === 'Primary' ) {
                    return 1;		
                }
                return 0;
            } );
            console.log( 'value vs list: ', value, list );
            
            const firstNames = list.map( name => name.firstname );
    
            // Handle the formatting based on the number of first names
            if (firstNames.length === 1) {
                // Only one first name
                return firstNames[0];
            } else {
                // Multiple first names, join all but the last with commas, and add 'and' before the last name
                const allButLast = firstNames.slice(0, -1).join(', ');
                const last = firstNames[firstNames.length - 1];
                return `${allButLast} and ${last}`;
            }
        } );
        Handlebars.registerHelper( 'borrowerPreferredFirstNames', function ( value ) {
            if ( value.length === 0) return '';
    
            const list = value.map( m => {
                const c = contacts[m.cid];
                return {
                    firstname: ( c.namePreferred && c.namePreferred.length ) ? c.namePreferred : c.firstname,
                    lastname: c.lastname,
                    label: m.label
                }
            } );
            list.sort( ( a, b ) => {
                if ( a.label === 'Primary' ) {
                    return -1;		
                }
                if ( b.label === 'Primary' ) {
                    return 1;		
                }
                return 0;
            } );
            
            const firstNames = list.map( name => name.firstname );
    
            // Handle the formatting based on the number of first names
            if ( firstNames.length === 1 ) {
                // Only one first name
                return firstNames[0];
            } else {
                // Multiple first names, join all but the last with commas, and add 'and' before the last name
                const allButLast = firstNames.slice( 0, -1 ).join( ', ' );
                const last = firstNames[firstNames.length - 1];
                return `${allButLast} and ${last}`;
            }
        } );
        Handlebars.registerHelper( 'borrowerFullNames', function ( value ) {
            if ( value.length === 0) return '';
    
            const list = value.map( m => {
                const c = contacts[m.cid];
                return {
                    firstname: c.firstname,
                    lastname: c.lastname,
                    label: m.label
                }
            } );
            list.sort( ( a, b ) => {
                if ( a.label === 'Primary' ) {
                    return -1;		
                }
                if ( b.label === 'Primary' ) {
                    return 1;		
                }
                return 0;
            } );
            
            // Group names by last name
            const groups = list.reduce((acc, { firstname, lastname }) => {
                acc[lastname] = acc[lastname] || [];
                acc[lastname].push(firstname);
                return acc;
            }, {});
            
            // Format each group
            const formattedGroups = Object.entries(groups).map(([lastname, firstnames]) => {
                if (firstnames.length === 1) {
                    // Single name in the group
                    return `${firstnames[0]} ${lastname}`;
                } else {
                    // Multiple names, join all but the last with commas, and add 'and' before the last name
                    const allButLast = firstnames.slice(0, -1).join(', ');
                    const last = firstnames[firstnames.length - 1];
                    return `${allButLast} and ${last} ${lastname}`;
                }
            });
    
            // Join groups with 'and' for the final output
            if (formattedGroups.length === 1) {
                return formattedGroups[0];
            } else {
                const lastGroup = formattedGroups.pop();
                return `${formattedGroups.join(', ')} and ${lastGroup}`;
            }
        } );
        Handlebars.registerHelper( 'borrowerEmails', function ( value ) {
            if ( value.length === 0 ) return '';
    
            const emails = new Set();
            value.forEach( f => {
                const c = contacts[f.cid];
                if ( c.email && c.email.length ) {
                    emails.add( c.email );
                }
            } );
            
            return [ ...emails ].join( ', ' );
        } );
        Handlebars.registerHelper( 'partnerEmails', function ( value ) {
            if ( value.length === 0 ) return '';
    
            const emails = new Set();
            value.forEach( f => {
                const c = contacts[f.cid];
                if ( c.email && c.email.length ) {
                    emails.add( c.email );
                }
                if ( c.emailPartner1 && c.emailPartner1.length ) {
                    emails.add( c.emailPartner1 );
                }
                if ( c.emailPartner2 && c.emailPartner2.length ) {
                    emails.add( c.emailPartner2 );
                }
            } );
            
            return [ ...emails ].join( ', ' );
        } );
        Handlebars.registerHelper( 'haveHas', function ( value ) {
            return ( value && value.length > 1 ) ? 'have' : 'has';
        } );
        Handlebars.registerHelper( 'aAn', function ( value ) {
            const vowels = "AEIOUaeiou";
            return ( value && vowels.includes( value[0] ) ) ? 'an' : 'a';
        } );
        Handlebars.registerHelper( 'singlePlural', function ( single, plural, bucket ) {
            return ( bucket && bucket.length > 1 ) ? plural : single;
        } );
        
        
        
        if ( objType === 'contact' ) {
            const refs = [];

            if ( obj.priRole === 'partner' ) {
                obj['activeLeads'] = false;
                obj['activePAs'] = false;
                obj['activeLoans'] = false;

                Object.keys( contacts ).forEach( cid => {
                    const c = contacts[cid];
                    if ( c.referredById === obj.cid ) {
                        console.log( c.name + ' is referred by ' + obj.name );
                        const los = [];
                        const ls = [];

                        Object.keys( opps ).forEach( o => {
                            const lo = opps[o];
                            if ( lo.relationships && lo.relationships.find( f => f.cid === c.cid ) ) {
                                const q = globalStatus.find( f => f.value === lo.status );

                                if ( [ 'lead', 'talking', 'app-sent', 'setup', 'review' ].includes( q?.queue ) ) {
                                    obj['activeLeads'] = true;
                                    lo['queue'] = 'lead';
                                    los.push( lo );
                                }
                            }
                        } );

                        Object.keys( loans ).forEach( lid => {
                            const l = loans[lid];
                            if ( l.borrowers && l.borrowers.find( f => f.cid === c.cid ) ) {
                                const q = loanStatus.find( f => f.value === l.status );

                                if ( q?.queue === 'pa' ) {
                                    obj['activePAs'] = true;
                                    l['queue'] = 'pa';
                                    ls.push( l );
                                }

                                if ( q?.queue === 'active' ) {
                                    obj['activeLoans'] = true;
                                    l['queue'] = 'active';
                                    ls.push( l );
                                }
                            }
                        } );

                        refs.push( {
                            ...c,
                            opps: los,
                            loans: ls
                        } );
                    }
                } );
            }

            params['contact'] = {
                ...obj,
                referredBy: contacts[obj.referredById],
                referrals: refs
            };

            console.log( 'params: ', params );
        } else if ( objType === 'loan' ) {
            const pri = obj.borrowers.find( f => f.label === 'Primary' );
            const c = contacts[pri.cid];
            const lp2 = user.lists.team.find( f => f.uid === obj.lp2 );
            params['contact'] = {
                ...c,
                referredBy: contacts[c.referredById]
            };
            params['loan'] = {
                ...obj,
                buyersAgent: contacts[obj.baId],
                buyersAgentTC: contacts[obj.baTcId],
                listingAgent: contacts[obj.laId],
                listingAgentTC: contacts[obj.laTcId],
                escrow: contacts[obj.escrowOfficerId],
                title: contacts[obj.titleRepId],
                lp2rep: lp2
            };
        }
        return t( { 
            ...params,
            user: user
        } );
    }, [ user, contacts, opps, loans, globalStatus, loanStatus, obj, objType ] );

    const prepAskAI = async ( prompt, ptype ) => {
        setPromptType( ptype );
        setPrompt( prompt );
        setShowChatGPT( true );
        setReplace( true );
    };

    const loadTemplates = ( editor ) => {
        let list = [];
        
        if ( Object.keys( tmplRef.current ).length ) {
            Object.keys( tmplRef.current ).sort().forEach( name => {
                const t = tmplRef.current[name];
                if ( !t.objects || t.objects.includes( objType ) ) {
                    const content = render( t.body );
                    let fresh = false;
                    let sig = '';

                    list.push( {
                        type: 'menuitem',
                        text: t.name,
                        onAction: () => {
                            if ( t.to ) {
                                const rTo = render( t.to );
                                const addrs = rTo.split( ',' );
                                setTo( addrs.filter( f => f.length > 4 ) );
                            }
                            if ( t.cc ) {
                                const rCc = render( t.cc );
                                const addrs = rCc.split( ',' );
                                setCc( addrs.filter( f => f.length > 4 ) );
                                setShowCc( true );
                            }
                            if ( t.bcc ) {
                                const rBcc = render( t.bcc );
                                const addrs = rBcc.split( ',' );
                                setBcc( addrs.filter( f => f.length > 4 ) );
                                setShowBcc( true );
                            }
                            if ( t.from ) {
                                const s = senderRef.current.find( f => f.email === t.from );
                                if ( s ) {
                                    setFrom( t.from );
                                    if ( s.signature && s.signature.length ) {
                                        sig = render( s.signature );
                                    } else if ( user.signature && user.signature.length ) {
                                        sig = render( user.signature );
                                    }
                                    fresh = true;
                                }
                            }
                            if ( t.subject ) {
                                setSubject( render( t.subject ) );
                                // setSubject( t.subject );
                            }
                            if ( t.attachments ) {
                                setAttachments( t.attachments );
                            }

                            if ( fresh ) {
                                editor.setContent( content + '<br /><br />' + sig );
                            } else {
                                editor.insertContent( content );
                            }
                            
                            setTmplUsed( t.tid );
                        }
                    } );
                }
            } );
        }
        if ( user.signature && user.signature.length ) {
            list.push( {
                type: 'menuitem',
                text: 'Signature',
                onAction: () => editor.insertContent( user.signature )
            } );
        }
        
        return ( list );
    }

    const loadPromptContextSubMenu = ( editor ) => {
        return [
            {
                type: 'item',
                text: 'Summarize',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'summarize' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: "item",
                text: 'Explain',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'explain' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Improve Writing',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'improve-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Simplify Writing',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'simplify-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Overcome Objection',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'objection-handler' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Check Guideline Accuracy',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'guideline-accuracy' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        // buttonApi.setEnabled( selectedText );
                    };
                    buttonApi.setEnabled( false );
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            }
        ]
    }

    const loadPromptContextMenu = ( editor ) => {
        return [
            {
                type: 'submenu',
                text: 'MortgageGPT',
                icon: 'ai',
                getSubmenuItems: () => {
                    const selectedText = editor.selection.getContent( { format: 'text' } );
                    return selectedText ? loadPromptContextSubMenu( editor ) : ''; // Show submenu items if text is selected
                },
            }
        ]
    }

    const loadPromptMenu = ( editor ) => {
        return [ 
            {
                type: 'menuitem',
                text: 'Overcome Objections',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'objection-handler' );
                }
            }, 
            {
                type: 'menuitem',
                text: 'Check Guideline Accuracy',
                enabled: false,
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'guideline-accuracy' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Suggest a Subject Line',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'subject-line-reco' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Summarize',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'summarize' );
                }
            },
            {
                type: 'menuitem',
                text: 'Explain',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'explain' );
                }
            },
            {
                type: 'menuitem',
                text: 'Improve Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'improve-writing' );
                }
            },
            {
                type: 'menuitem',
                text: 'Simplify Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'simplify-writing' );
                }
            }
        ]
    }

    // const resizeEditor = useCallback( () => {
    //     if ( editorRef.current ) {
    //         editorRef.current.ui.resize();
    //     }
    // }, [ editorHeight ] );

    useEffect( () => {
        if ( user?.stack?.ai?.copilot?.active ) {
            setAiEnabled( true );
        } else {
            setAiEnabled( false );
        }
    }, [ user ] );

    useEffect( () => {
        if ( open && !minimized && containerRef.current && windowHeaderRef.current && metaRef.current && actionsRef.current ) {
            console.log( 'container: ', containerRef.current.offsetHeight );
            console.log( 'windowHeader: ', windowHeaderRef.current.offsetHeight );
            console.log( 'meta: ', metaRef.current.offsetHeight );
            console.log( 'actions: ', actionsRef.current.offsetHeight );

            let h = containerRef.current.offsetHeight - windowHeaderRef.current.offsetHeight - metaRef.current.offsetHeight - actionsRef.current.offsetHeight;

            if ( leoRef.current ) {
                console.log( 'leo: ', leoRef.current.offsetHeight );
                h -= leoRef.current.offsetHeight;
            }

            if ( attachmentsRef.current ) {
                console.log( 'attachments: ', attachmentsRef.current.offsetHeight );
                h -= attachmentsRef.current.offsetHeight;
            }
            setEditorHeight( h - 20 );
            console.log( 'eref', editorRef.current );
            // resizeEditor();
        }
    }, [ attachments, aiEnabled, showCc, showBcc, open, minimized, recipSuggestions ] );

    useEffect( () => {
        setRecipSuggestions( prev => {
            return prev.filter( f => {
                return to.concat( cc ).concat( bcc ).find( e => e === f.email ) ? false : true;
            } );
        } );
    }, [ to, cc, bcc ] );

    useEffect( () => {
        if ( loading ) {
            const list = [];
            switch ( objType ) {
                case 'contact':
                    // handle primary contact
                    if ( obj.email && obj.email.length && !obj.optoutEmail ) {
                        setTo( [ obj.email.toLowerCase() ] );
                        // list.push( { name: obj.name, email: obj.email.toLowerCase() } );
                    }
                    // handle opp partners
                    if ( obj.priRole === 'borrower' ) {
                        Object.keys( opps ).forEach( loid => {
                            const lo = opps[loid];
                            if ( lo.relationships && lo.relationships.find( f => f.cid === obj.cid ) ) {
                                const cobos = lo.relationships.filter( f => f.cid !== obj.cid );
                                cobos.forEach( f => {
                                    const c = contacts[f.cid];
                                    if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                                        list.push( { name: c.name, email: c.email.toLowerCase() } );
                                    }
                                } );
                            }
                        } );
                    }
                    // handle contact partners
                    if ( obj.emailPartner1 && obj.emailPartner1.length && !list.find( e => e.email === obj.emailPartner1.toLowerCase() ) ) {
                        list.push( { name: `${obj.firstnamePartner1} ${obj.lastnamePartner1}`, email: obj.emailPartner1.toLowerCase() } );
                    }
                    if ( obj.emailPartner2 && obj.emailPartner2.length && !list.find( e => e.email === obj.emailPartner2.toLowerCase() ) ) {
                        list.push( { name: `${obj.firstnamePartner2} ${obj.lastnamePartner2}`, email: obj.emailPartner2.toLowerCase() } );
                    }
                    // handle referral source
                    if ( obj.referredById ) {
                        const c = contacts[obj.referredById];
                        if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                            list.push( { name: c.name, email: c.email.toLowerCase() } );
                        }
                    }
                    break;

                case 'loan':
                    // handle borrowers
                    if ( obj.borrowers && obj.borrowers.length ) {
                        const pri = obj.borrowers.find( f => f.label === 'Primary' );
                        if ( pri ) {
                            const c = contacts[pri.cid];
                            if ( c && c.email && c.email.length && !c.optoutEmail ) {
                                list.push( { name: c.name, email: c.email.toLowerCase() } );
                            }
                        }
                        const cobos = obj.borrowers.filter( f => f.label !== 'Primary' );
                        cobos.forEach( f => {
                            const c = contacts[f.cid];
                            if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                                list.push( { name: c.name, email: c.email.toLowerCase() } );
                            }
                        } );
                    }
                    // handle agents
                    if ( obj.baId ) {
                        const c = contacts[obj.baId];
                        if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                            list.push( { name: c.name, email: c.email.toLowerCase() } );
                        }
                    }
                    if ( obj.laId ) {
                        const c = contacts[obj.laId];
                        if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                            list.push( { name: c.name, email: c.email.toLowerCase() } );
                        }
                    }
                    break;

                default:
            }
            setRecipSuggestions( list );
        }
    }, [ objType, obj, loading, contacts, loans, opps ] );

    return (
        <div ref={ref}>
            <Container ref={containerRef} className='w-100'>
                <Row ref={windowHeaderRef} className='email-window-header p-0'>
                    <Col className='pe-0'>
                        <Row className='align-items-center w-100'>
                            <Col className='email-header-subject ps-3 pt-1'>
                                {
                                    !subject.length ? (
                                        <span>Draft Email</span>
                                    ) : (
                                        <span>{subject}</span>
                                    )
                                }
                            </Col>
                            <Col xs='auto' className='text-end px-0'>
                                <IconButton onClick={ () => { setMinimized( !minimized ); onMinimize(); } }>
                                    {
                                        minimized ? (
                                            <KeyboardArrowUpIcon fontSize='small' style={ { color: '#FFF' } } />
                                        ) : (
                                            <KeyboardArrowDownIcon fontSize='small' style={ { color: '#FFF' } } />
                                        )
                                    }
                                </IconButton>
                                <IconButton onClick={onClose}>
                                    <Close fontSize='small' style={ { color: '#FFF' } } />
                                </IconButton>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='email-window-body d-flex flex-column'>
                    <Col>
                        <Row ref={metaRef} className='email-window-meta flex-grow-0'>
                            <Col>
                                <Row className='py-1'>
                                    <Col>From</Col>
                                    <Col className='text-end' xs='auto'>
                                        <Button variant='link' className='tf-email-button-link pe-2' size='sm' onClick={() => setShowCc( !showCc )}>Cc</Button>
                                        <Button variant='link' className='tf-email-button-link ps-2' size='sm' onClick={() => setShowBcc( !showBcc )}>Bcc</Button>
                                    </Col>
                                </Row>
                                <Row className='py-1'>
                                    <Col>
                                        <EmailInput label="To" emails={to} setEmails={setTo} />
                                    </Col>
                                </Row>
                                {
                                    showCc ? (
                                        <Row className='py-1'>
                                            <Col>
                                                <EmailInput label="Cc" emails={cc} setEmails={setCc} />
                                            </Col>
                                        </Row>
                                    ) : (
                                        null
                                    )
                                }
                                {
                                    showBcc ? (
                                        <Row className='py-1'>
                                            <Col>
                                                <EmailInput label="Bcc" emails={bcc} setEmails={setBcc} />
                                            </Col>
                                        </Row>
                                    ) : (
                                        null
                                    )
                                }
                                {
                                    recipSuggestions.length ? (
                                        <Row className='tf-email-recip-suggestion-bar py-2'>
                                            <Col>
                                                <span className='tf-email-recip-suggestion-label fw-semibold pe-2'>Suggested Recipients:</span>
                                                {
                                                    recipSuggestions.map( ( r, i ) => {
                                                        return (
                                                            <Button key={i} variant='link' className='tf-email-button-link pe-2' size='sm' onClick={ () => setTo( [ ...to, r.email ] ) }>{r.name}</Button>
                                                        )
                                                    } )
                                                }
                                            </Col>
                                        </Row>
                                    ) : (
                                        null
                                    )
                                }
                                <Row className='tf-email-shadow-bottom pb-2' />
                                <Row className='tf-email-shadow-bottom py-2'>
                                    <Col className='tf-email-text-input ps-0'>
                                        <Form.Control type='text' value={subject} onChange={ ( e ) => setSubject( e.target.value ) } placeholder='Subject' />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {
                            aiEnabled ? (
                                <LeoSuggestionBar innerRef={leoRef} />
                            ) : (
                                null
                            )
                        }
                        <Row className="flex-grow-1" style={{ height: `${editorHeight}px`, overflowY: 'auto' }}>
                            <Col className='p-0' style={ { position: 'relative' } }>
                                { isDragActive && <div style={overlayStyle}>Drop Files Here...</div> }
                                <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} multiple />
                                <Editor
                                    tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                    init={ { 
                                        height: editorHeight,
                                        menubar: false, 
                                        statusbar: false,
                                        toolbar_mode: 'floating',
                                        toolbar_location: 'bottom',
                                        toolbar: 'bold italic underline formatting | link image tfattachment tfvideo emoticons tftmpl tfchatgpt tfaiprompts | code',
                                        toolbar_groups: {
                                            formatting: {
                                                icon: 'image-options',
                                                tooltip: 'Formatting',
                                                items: 'fontfamily fontsize | forecolor backcolor | align bullist numlist'
                                            }
                                        },
                                        visual: false,
                                        content_style: 'body { font-family:Arial; font-size:12pt; }',
                                        setup: ( editor ) => {
                                            editor.on( 'dragstart', handleDragEnter );
                                            editor.on( 'dragover', handleDragOver );
                                            editor.on( 'dragend', handleDragLeave );
                                            editor.on( 'dragleave', handleDragLeave );
                                            editor.on( 'drop', ( event ) => handleDrop( event, editor ) );
                                            editor.on( 'mouseleave', handleDragLeave );

                                            editor.ui.registry.addButton( 'tfvideo', {
                                                icon: 'embed',
                                                tooltip: 'Insert Video',
                                                enabled: true,
                                                onAction: (_) => {
                                                    setShowVideo( true );
                                                },
                                            } );
                                            editor.ui.registry.addMenuButton( 'tftmpl', {
                                                text: 'Templates',
                                                fetch: ( cb ) => {
                                                    const items = loadTemplates( editor );
                                                    cb( items );
                                                }
                                            } );
                                            editor.ui.registry.addMenuButton( 'tfaiprompts', {
                                                icon: 'ai-prompt',
                                                fetch: ( cb ) => {
                                                    const items = loadPromptMenu();
                                                    cb( items );
                                                }
                                                } );
                                            editor.ui.registry.addButton( 'tfchatgpt', {
                                                icon: 'ai',
                                                tooltip: 'Ask MortgageGPT',
                                                onAction: () => {
                                                    setShowChatGPT( true );
                                                }
                                            } );
                                            // Add custom paperclip icon
                                            editor.ui.registry.addIcon( 'tfpaperclip', `
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="#000000"  height="24" width="24" viewBox="0 0 36 36">
                                                <path d="M22.562,12.491c0,0,1.227-0.933,0.293-1.866c-0.934-0.933-1.842,0.271-1.842,0.271l-9.389,9.391
                                                c0,0-2.199,2.838-3.871,1.122c-1.67-1.718,1.121-3.872,1.121-3.872l12.311-12.31c0,0,2.873-3.165,5.574-0.466
                                                c2.697,2.7-0.477,5.579-0.477,5.579L12.449,24.173c0,0-4.426,5.113-8.523,1.015s1.066-8.474,1.066-8.474L15.494,6.209
                                                c0,0,1.176-0.982,0.295-1.866c-0.885-0.883-1.865,0.295-1.865,0.295L1.873,16.689c0,0-4.549,4.989,0.531,10.068
                                                c5.08,5.082,10.072,0.533,10.072,0.533l16.563-16.565c0,0,3.314-3.655-0.637-7.608s-7.607-0.639-7.607-0.639L6.543,16.728
                                                c0,0-3.65,2.969-0.338,6.279c3.312,3.314,6.227-0.39,6.227-0.39L22.562,12.491z"/>
                                                </svg>
                                            ` );
                                            // Add button using the custom paperclip icon
                                            editor.ui.registry.addButton( 'tfattachment', {
                                                icon: 'tfpaperclip',
                                                tooltip: 'Attach File',
                                                onAction: () => {
                                                    fileInputRef.current.click();
                                                }
                                            } );
                                                    
                                            editor.ui.registry.addContextMenu( 'aiContextMenu', {
                                                update: ( element ) => {
                                                    const selectedText = editor.selection.getContent( { format: 'text' } );
                                                    return selectedText ? loadPromptContextMenu( editor ) : ''; // Show the custom item if text is selected
                                                },
                                            } );
                                        },
                                        browser_spellcheck: true,
                                        contextmenu: 'aiContextMenu link',
                                        automatic_uploads: false,
                                        license_key: 'gpl'
                                    } }
                                    onInit={ ( evt, editor ) => {
                                        editorRef.current = editor;
                                    } }
                                    initialValue={body}
                                    plugins='emoticons code lists link image'
                                />
                            </Col>
                        </Row>
                        {
                            attachments.length ? (
                                <Row ref={attachmentsRef} className='py-2 me-0'>
                                    { attachments.map( a => <Col key={a.name} xs='auto' className='pe-0'><span className='tf-email-attachment-file'>{a.name}</span><span className='tf-email-attachment-delete' onClick={ () => removeAttachment( a.name ) }>X</span></Col>) }
                                </Row>
                            ) : (
                                null
                            )
                        }
                        <Row ref={actionsRef} className='tf-email-shadow-top align-items-center pt-3 mt-auto'>
                            <Col className='pe-2' xs='auto' style={ { zIndex: '9999' } }><ScheduleButton send={sendEmail} disabled={!subject.length || sending} /></Col>
                            {
                                subject.length ? (
                                    <Col className='pe-2' style={ { zIndex: '9999' } }>
                                        <Form.Group as={Row} className='tf-form-group align-items-center py-1' controlId='follow-up-task'>
                                            <Col className='pe-1' xs='auto'><Form.Check type='checkbox' className='tf-form-checkbox-field' onChange={ () => setIncludeTask( !includeTask ) } /></Col>
                                            <Col xs='auto'>
                                                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>
                                                    <Row className='align-items-center'>
                                                        <Col className='p-0' xs='auto'>Create a</Col>
                                                        <Col className='p-0 tf-email-task-select-input' xs='auto'>
                                                            <Form.Select className='ps-1'  value={taskType} onChange={ ( e ) => setTaskType( e.target.value ) }>
                                                                <option value="To-Do">To-Do</option>
                                                                <option value="Call">Call</option>
                                                                <option value="Text Msg">Txt</option>
                                                                <option value="Email">Email</option>
                                                            </Form.Select>
                                                        </Col>
                                                        <Col className='p-0' xs='auto'>task to follow up</Col>
                                                        <Col className='p-0 tf-email-task-select-input' xs='auto'>
                                                            <Form.Select className='ps-1' value={taskDay} onChange={ ( e ) => setTaskDay( e.target.value ) }>
                                                                <option value={1}>Tomorrow</option>
                                                                <option value={2}>This Friday</option>
                                                                <option value={3}>Next Monday</option>
                                                                <option value="Custom">Custom</option>
                                                            </Form.Select>
                                                        </Col>
                                                    </Row>
                                                </Form.Label>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                ) : (
                                    <Col className='pe-2' style={ { color: 'red', fontSize: '10px' } }>* Subject Required Before Sending</Col>
                                )
                            }
                            <Col className='ps-2 text-end' xs='auto'><Button variant='outline-dark' onClick={onClose}>Cancel</Button></Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
} );

const mapProps = ( state ) => ( {
    uid: state.user.email,
    user: state.user,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
    globalStatus: state.user.meta.global.picklist.status,
    loanStatus: state.user.meta.loan.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( EmailSingle );